import { IApplicationState } from '../../types/redux';

export function selectPlaceholderDisabled(state: IApplicationState) {
  return state.placeholderDisabled;
}
